import { Module } from 'vuex'

interface ModelAnswerPageState {
  pageIndex: number
  isFirstOpendPage: boolean
  isNotMoreModelAnswerList: boolean
  modelAnswerExpandedList: { [judgeId: number]: boolean }
  modelAnswerLoadingList: { [judgeId: number]: boolean }
  modelAnswerIsDiffList: { [judgeId: number]: boolean }
}

export const modelAnswerPageStateModule = (): Module<ModelAnswerPageState, any> => {
  return {
    namespaced: true,
    state: {
      pageIndex: 0,
      isFirstOpendPage: true,
      isNotMoreModelAnswerList: false,
      modelAnswerExpandedList: {},
      modelAnswerLoadingList: {},
      modelAnswerIsDiffList: {}
    },
    mutations: {
      setPageIndex(state, { pageIndex }: { pageIndex: number }) {
        state.pageIndex = pageIndex
      },
      setIsFirstOpendPage(state, { flag }: { flag: boolean }) {
        state.isFirstOpendPage = flag
      },
      setIsNotMoreModelAnswerList(state, { flag }: { flag: boolean }) {
        state.isNotMoreModelAnswerList = flag
      },
      setModelAnswerExpandedList(state, { list }: { list: { [judgeId: number]: boolean } }) {
        state.modelAnswerExpandedList = list
      },
      setModelAnswerExpandedFlag(state, { judgeId, flag }: { judgeId: number; flag: boolean }) {
        state.modelAnswerExpandedList[judgeId] = flag
      },
      setModelAnswerLoadingList(state, { list }: { list: { [judgeId: number]: boolean } }) {
        state.modelAnswerLoadingList = list
      },
      setModelAnswerLoadingFlag(state, { judgeId, flag }: { judgeId: number; flag: boolean }) {
        state.modelAnswerLoadingList[judgeId] = flag
      },
      setModelAnswerIsDiffList(state, { list }: { list: { [judgeId: number]: boolean } }) {
        state.modelAnswerIsDiffList = list
      },
      setModelAnswerIsDiffFlag(state, { judgeId, flag }: { judgeId: number; flag: boolean }) {
        state.modelAnswerIsDiffList[judgeId] = flag
      }
    },
    actions: {},
    getters: {
      pageIndex: state => state.pageIndex,
      isFirstOpendPage: state => state.isFirstOpendPage,
      isNotMoreModelAnswerList: state => state.isNotMoreModelAnswerList,
      modelAnswerExpandedList: state => state.modelAnswerExpandedList,
      modelAnswerLoadingList: state => state.modelAnswerLoadingList,
      modelAnswerIsDiffList: state => state.modelAnswerIsDiffList
    }
  }
}
